import { useContext } from '@nuxtjs/composition-api'

export default {
  methods: {
    $ensureRelatedPagesTitle(relatedPages) {
      const { i18n } = useContext()

      if (!relatedPages.title) {
        relatedPages.title = i18n.t('related-pages.title')
      }
      return relatedPages
    },
  },
}
